export const convertDateToDisplayFormat = (dateString) => {
    if (!dateString) return '';
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const date = new Date(dateString);
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
    return `${String(day).padStart(2, '0')}-${month}-${year}`;
};

export const convertDateFormat = (dateString) => {
    const months = {
        'Jan': '01', 'Feb': '02', 'Mar': '03', 'Apr': '04',
        'May': '05', 'Jun': '06', 'Jul': '07', 'Aug': '08',
        'Sep': '09', 'Oct': '10', 'Nov': '11', 'Dec': '12'
    };
    const parts = dateString.split('-');
    if (parts.length === 3) {
        const day = parts[0].padStart(2, '0');
        const month = months[parts[1]];
        const year = parts[2];
        return `${year}-${month}-${day}`;
    }
    return '';
};

export const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
};

export const generateSubjectId = (siteCode, subjects) => {
    if (!siteCode) return '';
    const siteSubjects = subjects.filter(s => String(s.subjectId).startsWith(siteCode));
    const lastNumber = siteSubjects.length;
    return `${siteCode}-${String(lastNumber + 1).padStart(3, '0')}`;
};